<template>
  <div class="rb-steps rb-wrap">
    <inactive-notice />
    <div class="rb-content" v-if="config">
      <step
        v-for="(data, indexStep) in config.steps"
        :key="`step-${indexStep}`"
        :data="data"
        :active="currentStep === indexStep"
        :selected-options="selectedOptions"
        :diamonds-data="diamondsData"
        :diamonds-meta="diamondsMeta"
        :api="config.api"
        :product="config.product"
        :mappings="config.mappings"
        :availability="availability"
        :url-shop="config.urlShop"
        :social-share="config.socialShare"
        :combine-price="config.combinePrice"
        :enable-v360="false"
      ></step>
    </div>
    <div class="rb-foot">
      <!-- <div class="rb-product-title-ios">{{ config?.product.title }}</div>
      <diamond-data
        mode="subscriber"
        :gia="true"
        :editable="true"
        class="large--hide medium--hide"
      /> -->
      <div class="rb-wrap">
        <div
          class="rb-pricing large--hide medium--hide small--flex small--one-whole small--justify-content-between"
        >
          <div>
            <pricing
              message-prev="Total Ring Price from "
              message-prev-complete="Total Ring Price "
              message-post="- Setting Price"
              :combine-price="config.combinePrice"
            />
            <!-- <stock-status-description /> -->
          </div>
          <button
            aria-label="Edit Diamond"
            @click.prevent="notifyEdit"
            class="rb-mobile-edit-diamond-btn"
          >
            Edit Diamond
          </button>
        </div>
        <div class="rb-pricing large--flex medium--flex small--hide">
          <div>
            <pricing
              message-prev="Total Ring Price from "
              message-prev-complete="Total Ring Price "
              message-post="- Setting Price"
              :combine-price="config.combinePrice"
            />
            <!-- <stock-status-description /> -->
          </div>
        </div>
        <div class="rb-controls">
          <button
            class="btn rb-btn-prev"
            aria-label="Previous Step"
            @click.prevent="notifyPrev"
            id="btn-previous-step"
            v-if="showPrev"
          >
            Prev
          </button>
          <button
            class="btn rb-btn-next"
            aria-label="Next Step"
            @click.prevent="notifyNext"
            :disabled="disableNext"
            id="btn-next-step"
            v-if="showNext"
          >
            {{ complete && currentStep == 5 ? "Finish" : "Next" }}
          </button>
          <button
            class="btn rb-btn-update"
            aria-label="Update"
            @click.prevent="notifyUpdate"
            id="btn-update"
            v-if="showUpdate"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/**
 * Steps Wrapper to control step display depending on user progress
 *
 * @props
 * config: Object
 * currentStep: Number
 * selectedOptions: Array
 * diamondsData: Object
 * diamondsMeta: Object
 * complete: Boolean
 * confirmed: Boolean
 * availability: Array
 *
 * @implements
 * CommMixin
 * TrackMixin
 *
 * @emits
 * rb-next-step
 * rb-prev-step
 * rb-update-step
 * rb-step-edit
 *
 */
import TrackMixin from "@/mixins/TrackMixin";
import CommMixin from "@/mixins/CommMixin";
import Step from "@/components/Step";
import Pricing from "@/components/Pricing";
import InactiveNotice from "@/components/InactiveNotice";
// import DiamondData from "@/components/DiamondData";
// import StockStatusDescription from "@/components/StockStatusDescription";
// import IconRingDiamond from "@/components/icons/IconRingDiamond";
export default {
  mixins: [CommMixin, TrackMixin],
  components: {
    Step,
    Pricing,
    // DiamondData,
    InactiveNotice,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    currentStep: {
      type: Number,
      default: 0,
    },
    selectedOptions: {
      type: Array,
      default: () => [],
    },
    diamondsData: {
      type: Object,
    },
    diamondsMeta: {
      type: Object,
    },
    complete: {
      type: Boolean,
      default: false,
    },
    confirmed: {
      type: Boolean,
      default: false,
    },
    availability: {
      type: Array,
    },
  },
  computed: {
    showPrev: function () {
      return this.currentStep > 0 && !this.confirmed;
    },
    showNext: function () {
      return this.currentStep < 6 && !this.confirmed;
    },
    showUpdate: function () {
      return this.complete && this.confirmed;
    },
    disableNext: function () {
      return !this.selectedOptions.find(
        (selectedOption) =>
          selectedOption.step.id === this.config.steps[this.currentStep].id
      );
    },
  },
  methods: {
    notifyNext: function (event) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.broadcast("rb-next-step");
    },
    notifyPrev: function (event) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.broadcast("rb-prev-step");
    },
    notifyUpdate: function (event) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.broadcast("rb-update-step");
    },
    notifyEdit: function (event) {
      this.trackEvent(
        this.formatTracking(this.getTrackId(event), this.TRACK_CLICK),
        this.getTrackId(event)
      );
      this.broadcast("rb-step-edit", { id: "diamond" });
    },
  },
};
</script>
